// @flow

import type { Language } from '../language.js';

export const getAgencyLink = (
  language: Language,
  agencySlug: string,
): string => {
  switch (language) {
    case 'en':
      return 'en/real-estate-agencies/agency-' + agencySlug;
    case 'de':
      return 'de/immobilienagenturen/agentur-' + agencySlug;
    case 'fr':
      return 'fr/agences-immobilieres/agence-' + agencySlug;
    case 'it':
      return 'it/agenzie-immobiliari/agenzia-' + agencySlug;
    case 'es':
      return 'es/agencias-inmobiliarias/agencia-' + agencySlug;
    default:
      return 'en/real-estate-agencies/agency-' + agencySlug;
  }
};
